<template>
  <dd-validation-rules-wrapper :name="name" :rules="rules">
    <template #default="validationWrapperProps">
      <validation-provider ref="provider" :name="name" :rules="validationWrapperProps.rules" v-slot="validationProps">
        <dd-input-wrapper
            :rules="validationWrapperProps.rules"
            :title="title"
            :errors="validationProps.errors"
            :name="name"
            :value="value"
            :disabled="disabled"
            :provider-ref="$refs.provider"
            v-slot="{validateInput}"
        >
          <textarea
              v-if="lazy"
              :data-dusk="dataDusk"
              :style="{
                minHeight: '80px',
              }"
               :name="name"
               :id="title"
               v-model.lazy="model"
               class="field"
              :class="[disabled ? 'disabled' : '']"
              :disabled="disabled"
               v-bind="$attrs"
              @blur="() => validateInput(value)"
           ></textarea>
          <textarea
              v-else
              :data-dusk="dataDusk"
              :style="{
                minHeight: '80px',
              }"
              :name="name"
              :id="title"
              v-model="model"
              class="field"
              :class="[disabled ? 'disabled' : '']"
              :disabled="disabled"
              v-bind="$attrs"
              @blur="() => validateInput(value)"
          />
        </dd-input-wrapper>
      </validation-provider>
    </template>
  </dd-validation-rules-wrapper>
</template>

<script>
export default {
  name: "DdTextarea",
  emits: ['input'],
  props: {
    dataDusk: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number],
      required: false,
    },
    rules: {
      type: [String, Array, Object],
      required: false,
    },
    lazy: Boolean,
    error: {
      value: String
    },
    disabled: {
      type: Boolean,
      required: false,
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
